// import React, { useCallback, useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { ReactComponent as BackIcon } from "../../../../../assets/svgs/back-button.svg";
// import TextStyles from "../../../../../components/Elements/TextStyles/TextStyles";
// import { getApi, postApi } from "../../../../../api/api_instance";
// import { API_URLS } from "../../../../../api/apiUrls";
// import { useSelector } from "react-redux";
// import toast from "react-hot-toast";
// import { THEME_COLORS } from "../../../../../color";
// import { IoArrowBackCircleOutline } from "react-icons/io5";

// const CreateNewTickets = () => {
//   const navigate = useNavigate();
//   const [formData, setFormData] = useState({
//     customerName: "",
//     userName: "",
//     email: "",
//     contactNumber: "",
//     helpText: "",
//   });
//   const token = useSelector((state) => state.auth.authToken);

//   const [errors, setErrors] = useState({});

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//     setErrors({ ...errors, [e.target.name]: "" }); // Clear error on change
//   };

//   const validateForm = () => {
//     let newErrors = {};
//     if (!formData.customerName)
//       newErrors.customerName = "Customer Name is required";
//     if (!formData.userName) newErrors.userName = "User Name is required";
//     if (!formData.email) newErrors.email = "Email ID is required";
//     if (!formData.contactNumber)
//       newErrors.contactNumber = "Contact Number is required";
//     if (!formData.helpText) newErrors.helpText = "This field is required";

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSubmit = async (e) => {
//     try {
//       e.preventDefault();
//       if (validateForm()) {
//         console.log("Form Data Submitted:", formData);

//         // Structure the data as required by the API
//         const requestData = {
//           query: formData.helpText, // Wrap the helpText in the "query" key
//         };

//         // Pass the token to the postApi function
//         const response = await postApi({
//           apiUrl: API_URLS.CREATE_TICKET,
//           data: requestData,
//           token: token,
//         });

//         if (response.success) {
//           toast.success("Ticket created successfully");
//           navigate("/organization/support");
//         }
//       }
//     } catch (error) {
//       console.error("Error in creating ticket", error);
//     }
//   };

//   // Ensure it runs when token is available

//   return (
//   <div className=" md:p-6 lg:p-0 bg-[#F5F5F5] mb-20 sm:mb-6 md:mb-6">
//       {/* <div className="flex items-center gap-2 text-xl font-bold">
//         <BackIcon onClick={() => navigate("/organization/support")} />
//         <TextStyles style={{ marginTop: "18px", color: THEME_COLORS.green }}>
//           #656523235
//         </TextStyles>
//       </div> */}

//      <div className="flex flex-wrap justify-end text-xs h-5 font-light gap-1 sm:gap-2">
//           <p>Home</p>
//           <span>/</span>

//           <TextStyles style={{ color: "#06513D" }}>
//             {" "}
//            support
//           </TextStyles>
//         </div>

//                 <div className="flex items-center gap-2 sm:mb-1.5 text-lg sm:text-xl font-bold flex-wrap">
//                   <IoArrowBackCircleOutline
//                     onClick={() => navigate(-1)}
//                     className="w-8 sm:w-10 h-8 sm:h-10 text-[#06513D] hover:text-white hover:bg-[#06513D] rounded-full transition"
//                   />
//                   <div className="text-[#06513D] font-[Calibri] text-[18px] sm:text-[20px] leading-none tracking-tight">
//                      #656523235
//                   </div>
//                 </div>
//       <div
//         style={{
//           border: "1px solid #3BA2B959",
//           borderRadius: "10px",
//           padding: "20px",
//           backgroundColor:"#fff",
//           boxShadow: "0px 0px 16px 0px #3BA2B91F",
//         }}
//       >
//         <form onSubmit={handleSubmit} className="space-y-4 my-20">
//           <div className="flex justify-between mx-20 mb-16">
//             <div>
//               <div>
//                 <label className="block font-semibold text-gray-500">
//                   Customer Name
//                 </label>
//                 <input
//                   type="text"
//                   name="customerName"
//                   value={formData.customerName}
//                   onChange={handleChange}
//                   className="w-96 p-2 border-b"
//                 />
//                 {errors.customerName && (
//                   <p className="text-red-500">{errors.customerName}</p>
//                 )}
//               </div>
//               <div className="mt-8">
//                 <label className="block font-semibold text-gray-500">
//                   Email ID
//                 </label>
//                 <input
//                   type="email"
//                   name="email"
//                   value={formData.email}
//                   onChange={handleChange}
//                   className="w-96 p-2 border-b "
//                 />
//                 {errors.email && <p className="text-red-500">{errors.email}</p>}
//               </div>
//             </div>
//             <div className="">
//               <div>
//                 <label className="block font-semibold text-gray-500">
//                   User Name
//                 </label>
//                 <input
//                   type="text"
//                   name="userName"
//                   value={formData.userName}
//                   onChange={handleChange}
//                   className="w-96 p-2 border-b "
//                 />
//                 {errors.userName && (
//                   <p className="text-red-500">{errors.userName}</p>
//                 )}
//               </div>

//               <div className="mt-8">
//                 <label className="block font-semibold text-gray-500">
//                   Contact Number
//                 </label>
//                 <input
//                   type="text"
//                   name="contactNumber"
//                   value={formData.contactNumber}
//                   onChange={handleChange}
//                   className="w-96 p-2 border-b "
//                 />
//                 {errors.contactNumber && (
//                   <p className="text-red-500">{errors.contactNumber}</p>
//                 )}
//               </div>
//             </div>
//           </div>
//           <div style={{ backgroundColor: "#B1C8C2" }} className="h-80">
//             <div className=" text-center ">
//               <label
//                 className="block font-semibold text-2xl  py-8"
//                 style={{ color: THEME_COLORS.green }}
//               >
//                 HOW CAN I HELP YOU??
//               </label>
//               <textarea
//                 name="helpText"
//                 value={formData.helpText}
//                 onChange={handleChange}
//                 className="w-11/12 p-2 border rounded h-20"
//               ></textarea>
//               {errors.helpText && (
//                 <p className="text-red-500">{errors.helpText}</p>
//               )}
//             </div>
//             <div className="text-center mt-6">
//               <button
//                 type="submit"
//                 style={{ background: "#06513D" }}
//                 className="text-[12px] text-white font-light px-8 py-4 rounded-md"
//               >
//                 Submit
//               </button>
//             </div>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default CreateNewTickets;

import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as BackIcon } from "../../../../../assets/svgs/back-button.svg";
import TextStyles from "../../../../../components/Elements/TextStyles/TextStyles";
import { getApi, postApi } from "../../../../../api/api_instance";
import { API_URLS } from "../../../../../api/apiUrls";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import { THEME_COLORS } from "../../../../../color";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import PopupCard from "../../../../Auth/PopupCard";
const CreateNewTickets = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    customerName: "",
    userName: "",
    email: "",
    contactNumber: "",
    helpText: "",
  });
  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState({
    type: "success",
    title: "Success",
    message: "",
  });

  const triggerPopup = (type, title, message, duration = 2000) => {
    setPopupData({ type, title, message });
    setShowPopup(true);
    setTimeout(
      () => setShowPopup(false),

      duration,
    );
  };

  const token = useSelector((state) => state.auth.authToken);

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "contactNumber") {
      const digitsOnly = value.replace(/\D/g, "");
      if (digitsOnly.length <= 10) {
        setFormData({ ...formData, [name]: digitsOnly });
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
    setErrors({ ...errors, [name]: "" }); // Clear error on change
  };

  const validateForm = () => {
    let newErrors = {};
    if (!formData.customerName)
      newErrors.customerName = "Customer Name is required";
    if (!formData.userName) newErrors.userName = "User Name is required";
    if (!formData.email) newErrors.email = "Email ID is required";
    if (!formData.contactNumber) {
      newErrors.contactNumber = "Contact Number is required";
    } else if (formData.contactNumber.length !== 10) {
      newErrors.contactNumber = "Contact Number must be exactly 10 digits";
    }
    if (!formData.helpText) newErrors.helpText = "This field is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  console.log("formData", formData);
  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      if (validateForm()) {
        console.log("Form Data Submitted:", formData);

        // Structure the data as required by the API
        const requestData = {
          customer_name: formData.customerName,
          user_name: formData.userName,
          email_id: formData.email,
          contact_no: formData.contactNumber,
          query: formData.helpText,
        };

        // Pass the token to the postApi function
        const response = await postApi({
          apiUrl: API_URLS.CREATE_TICKET,
          data: requestData,
          token: token,
        });

        // if (response.success) {
        //   //toast.success("Ticket created successfully");
        //   triggerPopup("success", "Success", "Ticket created successfully");

        //   navigate("/organization/support");
        // }
        if (response.success) {
          triggerPopup("success", "Success", "Ticket created successfully");

          // Wait until popup is visible, then navigate
          setTimeout(() => {
            navigate("/organization/support");
          }, 2000); // same duration as popup
        }
      }
    } catch (error) {
      console.error("Error in creating ticket", error);
    }
  };

  return (
    <div className="w-full max-w-full overflow-x-hidden">
      {/* Main Container */}
      <div className="px-3 sm:px-4 md:px-6 lg:px-0 bg-[#F5F5F5] mb-20 sm:mb-6 md:mb-6">
        {/* Breadcrumbs */}
        <div className="flex flex-wrap justify-end text-xs h-5 font-light gap-1 sm:gap-2 ">
          <p>Home</p>
          <span>/</span>
          <TextStyles style={{ color: "#06513D" }}>support</TextStyles>
        </div>

        {/* Header Section */}
        <div className="flex items-center gap-2 sm:gap-3  text-lg sm:text-xl font-bold flex-wrap">
          <IoArrowBackCircleOutline
            onClick={() => navigate(-1)}
            className="w-7 h-7 sm:w-8 sm:h-8 md:w-10 md:h-10 text-[#06513D] hover:text-white hover:bg-[#06513D] rounded-full transition cursor-pointer flex-shrink-0"
          />
          <div className="text-[#06513D] font-[Calibri] text-[16px] sm:text-[18px] md:text-[20px] font-bold">
            Support
          </div>
        </div>

        {/* Main Content Card */}
        <div
          className="w-full overflow-hidden"
          style={{
            border: "1px solid #3BA2B959",
            borderRadius: "10px",
            padding: "15px",
            backgroundColor: "#fff",
            boxShadow: "0px 0px 16px 0px #3BA2B91F",
          }}
        >
          <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-6">
            {/* Form Fields Section */}
            <div className="mt-4 sm:mt-6 md:mt-8 lg:mt-12 xl:mt-16">
              {/* Desktop Layout - Two Columns */}
              <div className="hidden lg:flex justify-between mx-4 xl:mx-20 mb-8 xl:mb-16">
                <div className="w-full max-w-md">
                  <div className="mb-6 xl:mb-8">
                    <label className="block font-semibold text-gray-500 mb-2">
                      Customer Name
                    </label>
                    <input
                      type="text"
                      name="customerName"
                      value={formData.customerName}
                      onChange={handleChange}
                      className="w-full p-2 border-b border-gray-300 focus:border-[#06513D] focus:outline-none"
                    />
                    {errors.customerName && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.customerName}
                      </p>
                    )}
                  </div>
                  <div>
                    <label className="block font-semibold text-gray-500 mb-2">
                      Email ID
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="w-full p-2 border-b border-gray-300 focus:border-[#06513D] focus:outline-none"
                    />
                    {errors.email && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.email}
                      </p>
                    )}
                  </div>
                </div>
                <div className="w-full max-w-md">
                  <div className="mb-6 xl:mb-8">
                    <label className="block font-semibold text-gray-500 mb-2">
                      User Name
                    </label>
                    <input
                      type="text"
                      name="userName"
                      value={formData.userName}
                      onChange={handleChange}
                      className="w-full p-2 border-b border-gray-300 focus:border-[#06513D] focus:outline-none"
                    />
                    {errors.userName && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.userName}
                      </p>
                    )}
                  </div>
                  <div>
                    <label className="block font-semibold text-gray-500 mb-2">
                      Contact Number
                    </label>
                    <input
                      type="text"
                      name="contactNumber"
                      value={formData.contactNumber}
                      onChange={handleChange}
                      className="w-full p-2 border-b border-gray-300 focus:border-[#06513D] focus:outline-none"
                    />
                    {errors.contactNumber && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.contactNumber}
                      </p>
                    )}
                  </div>
                </div>
              </div>

              {/* Tablet and Mobile Layout - Single Column */}
              <div className="block lg:hidden px-2 sm:px-4 md:px-6 mb-6 md:mb-8">
                <div className="space-y-4 sm:space-y-6">
                  <div>
                    <label className="block font-semibold text-gray-500 mb-2 text-sm sm:text-base">
                      Customer Name
                    </label>
                    <input
                      type="text"
                      name="customerName"
                      value={formData.customerName}
                      onChange={handleChange}
                      className="w-full p-2 border-b border-gray-300 focus:border-[#06513D] focus:outline-none text-sm sm:text-base"
                    />
                    {errors.customerName && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.customerName}
                      </p>
                    )}
                  </div>
                  <div>
                    <label className="block font-semibold text-gray-500 mb-2 text-sm sm:text-base">
                      User Name
                    </label>
                    <input
                      type="text"
                      name="userName"
                      value={formData.userName}
                      onChange={handleChange}
                      className="w-full p-2 border-b border-gray-300 focus:border-[#06513D] focus:outline-none text-sm sm:text-base"
                    />
                    {errors.userName && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.userName}
                      </p>
                    )}
                  </div>
                  <div>
                    <label className="block font-semibold text-gray-500 mb-2 text-sm sm:text-base">
                      Email ID
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="w-full p-2 border-b border-gray-300 focus:border-[#06513D] focus:outline-none text-sm sm:text-base"
                    />
                    {errors.email && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.email}
                      </p>
                    )}
                  </div>
                  <div>
                    <label className="block font-semibold text-gray-500 mb-2 text-sm sm:text-base">
                      Contact Number
                    </label>
                    <input
                      type="text"
                      name="contactNumber"
                      value={formData.contactNumber}
                      onChange={handleChange}
                      className="w-full p-2 border-b border-gray-300 focus:border-[#06513D] focus:outline-none text-sm sm:text-base"
                    />
                    {errors.contactNumber && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.contactNumber}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Help Section */}
            <div
              style={{ backgroundColor: "#B1C8C2" }}
              className="rounded-lg p-4 sm:p-6 md:p-8 min-h-[250px] sm:min-h-[280px] md:min-h-[320px]"
            >
              <div className="text-center">
                <label
                  className="block font-semibold text-lg sm:text-xl md:text-2xl mb-4 sm:mb-6 md:mb-8"
                  style={{ color: THEME_COLORS.green }}
                >
                  HOW CAN I HELP YOU??
                </label>
                <textarea
                  name="helpText"
                  value={formData.helpText}
                  onChange={handleChange}
                  placeholder="Please describe your issue..."
                  className="w-full max-w-4xl p-3 sm:p-4 border border-gray-300 rounded-md h-16 sm:h-20 md:h-24 resize-none focus:border-[#06513D] focus:outline-none text-sm sm:text-base"
                />
                {errors.helpText && (
                  <p className="text-red-500 text-sm mt-2">{errors.helpText}</p>
                )}
              </div>
              <div className="text-center mt-4 sm:mt-6">
                <button
                  type="submit"
                  style={{ background: "#06513D" }}
                  className="text-xs sm:text-sm text-white font-light hover:!bg-[#387464] px-6 sm:px-8 py-3 sm:py-4 rounded-md hover:bg-opacity-90 transition-colors min-w-[100px] sm:min-w-[120px]"
                >
                  Submit
                </button>
              </div>
            </div>
          </form>
          {showPopup && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
              <PopupCard
                type={popupData.type}
                title={popupData.title}
                message={popupData.message}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CreateNewTickets;
